// Profile field validation shared by the buyer profile card and the
// admin/advisor profile form. Mirrors the backend checks in
// app/routers/profile.py (update_profile) — keep the two in sync.

export const NAME_MAX_LENGTH = 60;

/** Letters (incl. accented), spaces, hyphens, apostrophes, periods. */
const NAME_RE = /^[A-Za-zÀ-ÖØ-öø-ÿ' .-]+$/;

export function nameIssue(value: string, label: string): string | null {
  const v = value.trim();
  if (!v) return `${label} is required`;
  if (v.length > NAME_MAX_LENGTH) return `${label} must be at most ${NAME_MAX_LENGTH} characters`;
  if (!NAME_RE.test(v)) return `${label} can only contain letters, spaces, hyphens, and apostrophes`;
  return null;
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function emailIssue(value: string, label = "Email"): string | null {
  const v = value.trim();
  if (!v) return `${label} is required`;
  if (!EMAIL_RE.test(v)) return `Enter a valid ${label.toLowerCase()}`;
  return null;
}

/**
 * Phone is optional; when provided it must be a real 10-digit number
 * (a leading US "1" is tolerated), matching formatPhone's convention.
 */
export function phoneIssue(value: string): string | null {
  const v = value.trim();
  if (!v) return null;
  if (!/^[\d\s()+.-]+$/.test(v)) return "Phone can only contain digits, spaces, and + ( ) - .";
  const digits = v.replace(/\D/g, "");
  const national = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
  if (national.length !== 10) return "Enter a 10-digit phone number";
  return null;
}
